import { Cirus } from "@/classes/Http";

export function deleteInventory(instance_id: number, address_id: string) {
    const path = `/instance/${instance_id}/inventory/${address_id}`;
    return Cirus.delete(path);
}